import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        const translateService = this.injector.get(TranslateService);
        if (err.status === 400) {
          return throwError({ status: err.status, error: err.error });
        } else if (err.status === 401 || err.status === 409) {
          return throwError({
            status: err.status,
            message: err.error.message || err.statusText,
          });
        } else if (err.status === 404) {
          return throwError({
            message:
              err.error.error || translateService.instant('common.errors.404'),
            status: 404,
          });
        } else if (err.status === 403) {
          this.router.navigate(['/dashboard']);
          return throwError({
            status: err.status,
            message: 'Acceso no autorizado',
          });
        } else if (err.status === 422) {
          return throwError({
            status: err.status,
            ...err.error,
          });
        } else if (err.status === 500) {
          this.router.navigate(['/500'], {
            state: { error: err.error.message || err.statusText },
          });
        }

        return throwError(err.error.message || err.statusText);
      })
    );
  }
}
